import { ImpersonateUser } from './ImpersonateUser';
import { AdminApi, CustomersApi } from './apis';
import { iBinderFetch } from './iBinderFetch';

export const ImpersonateTenant = async ({ tenantId }) => {
  let userIdToImpersonate = null;
  const tenantFetch = iBinderFetch({ tenantId });

  const tenantResponse = await (
    await tenantFetch(`${CustomersApi}/Organizations/${tenantId}`)
  ).json();

  if (tenantResponse.market.name === 'Personal') {
    userIdToImpersonate = tenantId;
  } else {
    const adminTenantResponse = await (
      await tenantFetch(`${AdminApi}/Organizations/${tenantId}`)
    ).json();
    userIdToImpersonate = adminTenantResponse.admins[0].userId;
  }

  await ImpersonateUser({ userId: userIdToImpersonate });
};
